export const DEFAULT_TIME_OF_DAY = '00:00'; // nur für Uhrzeiten verwenden!
export const DEFAULT_TIME = '0:00'; // für Zeitdauern verwenden!
const DAY_IN_MINUTES = 1440;

export default {

    // nur für Zeitdauern verwenden!
    formatMinutesToWorkingHours(timeInMinutes) {
        if (timeInMinutes == undefined) return undefined;

        var hours = Math.trunc(timeInMinutes / 60);
        var minutes = (timeInMinutes % 60).toFixed(0);

        let prefix = '';
        if (hours < 0) { prefix = '-'; hours = hours * -1 }
        if (minutes < 0) { minutes = minutes * -1;}

        if (minutes < 10) minutes = '0' + minutes;

        return prefix + hours + ':' + minutes;
    },

    mapTimeAmountToMinutes(time) {
        if (time == undefined)
            return time;

        var industryTime = this.mapIndustyFormatToMinutes(time);
        if (industryTime != undefined)
            return industryTime;

        return this.mapRegularFormatToMinutes(time);
    },

    mapRegularFormatToMinutes(regularFormatTime) {
        if (regularFormatTime == undefined)
            return undefined;

        regularFormatTime = regularFormatTime.trim();

        var minutes = 0;

        if (/\d+[:]\d*/.test(regularFormatTime)) {
            var timeFragments = regularFormatTime.trim().split(':');

            const hasMinus = (/-{1}/).test(regularFormatTime);
            const tmpHours = parseInt(timeFragments[0]) * 60;
            const tmpMinutes = parseInt(isNaN(timeFragments[1]) ? '0' : timeFragments[1]);

            minutes = hasMinus ? tmpHours - tmpMinutes : tmpHours + tmpMinutes;
        }
        else if (regularFormatTime.length < 3) {
            minutes = parseInt(regularFormatTime) * 60;
        }
        else {
            var hours = parseInt(regularFormatTime.slice(0, -2));
            minutes = hours * 60 + parseInt(regularFormatTime.substring(regularFormatTime.length - 2, regularFormatTime.length));
        }

        return isNaN(minutes) ? undefined : minutes;
    },

    mapIndustyFormatToMinutes(industryFormatTime) {
        if (industryFormatTime == undefined || !/\d+[.,]\d*/.test(industryFormatTime))
            return undefined;

        var timeFragments = industryFormatTime.trim().replace(',', '.').split('.');

        var additionalPercentageHours = timeFragments.length > 1 ? timeFragments[1] : '0';

        var minutes = (parseInt(timeFragments[0]) + parseInt(additionalPercentageHours) / Math.pow(10, additionalPercentageHours.length)) * 60;

        return isNaN(minutes) ? undefined : minutes;
    },

    sumAllTimes(timeArray) {
        return timeArray.reduce((accumulator, timeAsString) => {
            const timeAsNumber = this.mapRegularFormatToMinutes(timeAsString);
            return accumulator + timeAsNumber;
        }, 0);
    },

    addMinutesToTime(time, minutes) {
        if (!time) return this.formatMinutesToWorkingHours(minutes)
        else {
            var timeInMinutes = this.mapTimeAmountToMinutes(time);
            timeInMinutes+= minutes;
            return timeInMinutes >= DAY_IN_MINUTES ? DEFAULT_TIME : this.formatMinutesToWorkingHours(timeInMinutes)
        }
    },

    substractMinutesOfTime(time, minutes) {
        var timeInMinutes = this.mapTimeAmountToMinutes(time);
        timeInMinutes-= minutes;
        return timeInMinutes <= 0 ? DEFAULT_TIME : this.formatMinutesToWorkingHours(timeInMinutes)
    },

    mapMinutesToIndustryFormat(minutes) {
        if (minutes == undefined || isNaN(minutes)) 
            return undefined;
        
        const totalHours = minutes / 60;
        const wholeHours = Math.trunc(Math.abs(totalHours));
        const decimalPart = Math.abs(totalHours) - wholeHours;
        const industryDecimal = Math.round(decimalPart * 100);
        
        const sign = totalHours < 0 ? '-' : '';
        const decimal = industryDecimal ? `.${industryDecimal.toString().padStart(2, '0')}` : '';
        
        return `${sign}${wholeHours}${decimal}`;
    },
}
